import React, { useState, useEffect } from "react";
import classes from './Settings.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import Footer from "../../Components/Footer/Footer";
import api from "../../Components/API/Api";
import { Eye, Edit, Trash } from 'lucide-react';

const Settings = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [metrics, setMetrics] = useState({
        total: 0,
        active: 0,
        inactive: 0,
    });

    const [loading, setLoading] = useState(false);
    const [openMenuIndex, setOpenMenuIndex] = useState(null);

    // Pagination States
    // const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 50;

    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [from, setFrom] = useState(0);
    const [to, setTo] = useState(0);

    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    useEffect(() => {
        fetchStocks();
        fetchMetrics();
    }, []);

    const fetchStocksOld = async () => {
        setLoading(true);

        try {
            const res = await api.get(`/v1/savings_product/paginate`);
            // const res = await api.get(`/v1/fetch_stocks`);

            if (Array.isArray(res.data?.data)) {
                setData(res.data.data);
            } else {
                setData([]);
            }
        } catch (error) {
            console.error("Error fetching stocks:", error);
        }

        setLoading(false);
    };


    const fetchStocks = async (page = 1) => {
    setLoading(true);

    try {
        const res = await api.get(
            `/v1/savings_product/paginate?page=${page}`
        );

        const payload = res.data?.data;

        if (payload?.data) {
            setData(payload.data);

            setCurrentPage(payload.current_page);
            setLastPage(payload.last_page);
            setTotal(payload.total);
            setFrom(payload.from || 0);
            setTo(payload.to || 0);
        } else {
            setData([]);
        }
    } catch (error) {
        console.error("Error fetching products:", error);
    }

    setLoading(false);
};

    const fetchMetrics = async () => {
        try {
            const res = await api.get(`/v1/stock_metrics`);

            if (res.data?.data) {
                setMetrics({
                    total: res.data.data.total_stock || 0,
                    active: res.data.data.active_stock || 0,
                    inactive: res.data.data.inactive_stock || 0,
                });
            }
        } catch (error) {
            console.error("Error fetching stock metrics:", error);
        }
    };

    // Pagination Logic
    const totalPages = Math.ceil(data.length / rowsPerPage);

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;

    const currentRows = data.slice(indexOfFirstRow, indexOfLastRow);

    const handlePageChangeOld = (page) => {
        setCurrentPage(page);
        setSelectedRows([]);
    };

    const handlePageChange = (page) => {
    setSelectedRows([]);
    fetchStocks(page);
};

    // Select All
    const allSelectedOld =
        currentRows.length > 0 &&
        currentRows.every((_, index) =>
            selectedRows.includes(indexOfFirstRow + index)
        );

    const allSelected =
    data.length > 0 &&
    data.every((_, index) =>
        selectedRows.includes(index)
    );

    const handleSelectAll = () => {
    const currentIndexes = data.map((_, index) => index);

    if (allSelected) {
        setSelectedRows([]);
    } else {
        setSelectedRows(currentIndexes);
    }
};

    const handleSelectAllOld = () => {
        const currentPageIndexes = currentRows.map(
            (_, index) => indexOfFirstRow + index
        );

        if (allSelected) {
            setSelectedRows((prev) =>
                prev.filter((row) => !currentPageIndexes.includes(row))
            );
        } else {
            setSelectedRows((prev) => [
                ...new Set([...prev, ...currentPageIndexes]),
            ]);
        }
    };

    const handleSelectRow = (index) => {
        setSelectedRows((prev) =>
            prev.includes(index)
                ? prev.filter((row) => row !== index)
                : [...prev, index]
        );
    };

    const formatCurrency = (amount) => {
        if (!amount && amount !== 0) return "";

        return `₦${Number(amount).toLocaleString("en-NG", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })}`;
    };

    const handleEditProduct = (product) => {
        navigate(`/settings/products&services/new-items/add-product`, {
            state: { product, isEdit: true }
        });
    };

    const handleDeleteProduct = (productId) => {
        if (window.confirm("Are you sure you want to delete this product?")) {
            setLoading(true);

            api.delete(`/v1/delete_stock/${productId}`)
                .then(() => {
                    setData((prev) =>
                        prev.filter((item) => item.id !== productId)
                    );

                    alert("Product deleted successfully");
                })
                .catch((error) => {
                    console.error("Error deleting product:", error);
                    alert("Failed to delete product");
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />

            <div className={classes.Container}>

                {/* Top Buttons */}
                {/* <div className={classes.actions}>
                    <button
                        className={classes.btns}
                        onClick={() => navigate("/transactions/sales-invoice/sale")}
                    >
                        Sales Invoice
                    </button>

                    <button
                        className={classes.btns}
                        onClick={() => navigate("/inventory/purchaseOrder")}
                    >
                        Purchase Invoice
                    </button>

                    <button
                        className={classes.btns}
                        onClick={() => navigate("/inventory/stocks_delivery")}
                    >
                        Stock Delivery
                    </button>

                    <button className={`${classes.btnss} ${classes.greens}`}>
                        Product & Services
                    </button>
                </div> */}

                {/* Header */}
                <header className={classes.Header}>
                    <h2 className={classes.Title}>Savings Product</h2>

                    <h1 className={classes.Titles}>
                         Create, edit, and configure the different types of savings plans available for members to subscribe to.
                    </h1>
                </header>

                {/* Metrics */}
                {/* <div className={classes.entrjj}>
                    <div className={classes.allkads}>

                        <div className={classes.thrdkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>{metrics.total}</p>

                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Total Items</p>
                                </div>
                            </div>
                        </div>

                        <div className={classes.frtkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>{metrics.active}</p>

                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Active Items</p>
                                </div>
                            </div>
                        </div>

                        <div className={classes.fiftkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>{metrics.inactive}</p>

                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Inactive Items</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div> */}

                {/* Search */}
                <div className={classes.headerActions}>
                    <div className={classes.inputWrapper}>
                            <input
                                type="text"
                                className={classes.searchBar}
                                placeholder="Search..."
                            />

                            <img
                                src={searchicon}
                                alt="Search"
                                className={classes.inputIconGreen}
                            />
                        </div>

                    <div className={classes.actionsRight}>
                        

                        {/* <div className={classes.inputWrapper}>
                            <input
                                type="text"
                                className={classes.searchBar}
                                placeholder="Filter..."
                            />

                            <img
                                src={filter}
                                alt="Filter"
                                className={classes.inputIcon}
                            />
                        </div> */}

                        <button
                            className={classes.btnss}
                            onClick={() =>
                                navigate("/settings/products&services/new-items/add-product")
                            }
                        >
                            + Add Products
                        </button>
                    </div>
                </div>

                {/* Table */}
                <div className={classes.tableContainer}>
                    <table className={classes.table}>
                        <thead>
                            <tr>
                                {/* <th>
                                    <input
                                        type="checkbox"
                                        checked={allSelected}
                                        onChange={handleSelectAll}
                                    />
                                </th> */}

                                <th>Code</th>
                                <th>Name</th>
                                {/* <th>Description</th> */}
                                {/* <th>Type</th> */}
                                <th>Contribution Frequency</th>
                                {/* <th>Interest Calculation</th> */}
                                <th>Interest Posting</th>
                                <th>Min Contribution</th>
                                <th>Max Contribution</th>
                                {/* <th>Status</th> */}
                                <th>Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {loading ? (
                                Array.from({ length: 5 }).map((_, i) => (
                                    <tr key={i}>
                                        {Array.from({ length: 9 }).map((_, j) => (
                                            <td key={j}>
                                                <div className={classes.skeleton}></div>
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : data.length > 0 ? (
                                data.map((item, i) => {
                                    const realIndex = i;

                                    return (
                                        <tr key={item.id}>
                                            {/* <td>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedRows.includes(realIndex)}
                                                    onChange={() =>
                                                        handleSelectRow(realIndex)
                                                    }
                                                />
                                            </td> */}

                                            <td>{item.product_code}</td>

                                            <td>{item.product_name}</td>

                                            {/* <td>{item.description || "—"}</td> */}

                                            {/* <td>{item.product_type || "—"}</td> */}

                                            <td>{item.contribution_frequency || "—"}</td>

                                            {/* <td>{item.interest_calculation || "—"}</td> */}

                                            <td>
                                                {item.interest_posting}
                                            </td>

                                            <td style={{ textAlign: "right" }}>
                                                {formatCurrency(item.min_contribution)}
                                            </td>
                                            <td style={{ textAlign: "right" }}>
                                                {formatCurrency(item.max_contribution)}
                                            </td>
                                            <td className={classes.tableCell}>
                        <div className={classes.actionIcons}>
                          <Eye size={16} style={{ color: 'rgba(22, 163, 74, 1)' }} />
                          <Edit 
                            size={16} 
                            style={{ margin: '0 8px', color: 'rgba(37, 99, 235, 1)', cursor: 'pointer' }}
                            onClick={() => handleEditProduct(item)}
                          />
                          <Trash size={16} style={{ color: 'rgb(255, 2, 2)' }} />
                        </div>
                      </td>

                                            {/* <td style={{ textAlign: "right" }}>
                                                {item.quantity}
                                            </td> */}

                                            {/* <td>
                                                <span className={classes.activeStatus}>
                                                    {item.status === "1"
                                                        ? "Active"
                                                        : "Inactive"}
                                                </span>
                                            </td> */}

                                            {/* <td style={{ position: "relative" }}>
                                                <button
                                                    className={classes.menuButton}
                                                    onClick={() =>
                                                        setOpenMenuIndex(
                                                            openMenuIndex === realIndex
                                                                ? null
                                                                : realIndex
                                                        )
                                                    }
                                                >
                                                    ⋮
                                                </button>

                                                {openMenuIndex === realIndex && (
                                                    <div className={classes.dropdownMenu}>
                                                        <button
                                                            className={classes.menuItem}
                                                            onClick={() => {
                                                                handleEditProduct(item);
                                                                setOpenMenuIndex(null);
                                                            }}
                                                        >
                                                            Edit
                                                        </button>

                                                        <button
                                                            className={classes.menuItem}
                                                            onClick={() => {
                                                                handleDeleteProduct(item.id);
                                                                setOpenMenuIndex(null);
                                                            }}
                                                        >
                                                            Delete
                                                        </button>
                                                    </div>
                                                )}
                                            </td> */}
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td
                                        colSpan="12"
                                        style={{ textAlign: "center" }}
                                    >
                                        No products/services found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
<table className={classes.footerTable}>
    <tfoot>
        <tr>

            <td
                style={{
                    cursor:
                        currentPage === 1
                            ? "not-allowed"
                            : "pointer"
                }}
                onClick={() =>
                    currentPage > 1 &&
                    handlePageChange(currentPage - 1)
                }
            >
                Prev
            </td>

            {Array.from(
                { length: lastPage },
                (_, i) => (
                    <td
                        key={i}
                        className={`${classes.page} ${
                            currentPage === i + 1
                                ? classes.activePage
                                : ""
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                            handlePageChange(i + 1)
                        }
                    >
                        {i + 1}
                    </td>
                )
            )}

            <td
                style={{
                    cursor:
                        currentPage === lastPage
                            ? "not-allowed"
                            : "pointer"
                }}
                onClick={() =>
                    currentPage < lastPage &&
                    handlePageChange(currentPage + 1)
                }
            >
                Next
            </td>

        </tr>
    </tfoot>
</table>
                {/* Display */}
<div className={classes.paginationDisplay}>
    Displaying {from} - {to} of {total}
</div>
            </div>

            <Footer />
        </div>
    );
};

export default Settings;